import React from 'react';
import { observer } from 'mobx-react-lite';
import 'mobx-react-lite/batchingForReactDom';
import { useStores } from '../../../hooks';
import { SimulcastTable } from '../../../elements';
import { schema } from './schema';

const ProductsHome = observer(({ LaneID, AuctionID, MediaState }) => {
  const {
    ProductsStore: {
      isLoading,
      loadProductsByAuction: dataByAuction,
      loadProductsByLane: dataByLane,
      data,
      totalItems,
    },
  } = useStores();

  const {
    headerSchema,
    tableSettings: {
      getMethods,
      initialSortColumn,
      pageSelectTitle,
      searchFields,
    },
    bodySchema,
    debugging,
  } = schema;

  const lane = { id: LaneID, fn: dataByLane };
  const auction = { id: AuctionID, fn: dataByAuction };
  const methods = getMethods(lane, auction);

  return (
    <SimulcastTable
      bodySchema={bodySchema}
      debugging={debugging}
      headerSchema={headerSchema}
      initialMediaState={MediaState}
      initialSortColumn={initialSortColumn}
      isLoading={isLoading}
      methods={methods}
      pageSelectTitle={pageSelectTitle}
      searchFields={searchFields}
      rowData={data}
      totalItems={totalItems}
      exportButton={{
        visible: data.length > 0,
        fileName: `ProductsReport-${AuctionID}`,
        sheetName: 'Products Report',
        showLocation: ['top'],
      }}
    />
  );
});

export default ProductsHome;
